
import dayjs from "dayjs";
import 'dayjs/plugin/customParseFormat';
import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";


const UpdateChildRollDetail = async (open, setOpen, severityvalue, setseverityvalue, messageValue, setmessageValue, alertTitleValue, setAlertTitleValue, ParentRollNumber, setChildRollsDetails, get_SelectedLotNumber_status, setSetwiseChildrollDetail, setApprovedChildRollNumber, setgetChildReelAchievement, createChildBtnDisapled, setCreateChildBtnDisapled, winderMoNumber, winderMaNumber, shiftDate, winderShiftCode) => {

    setOpen(false);
    const orderData = {
        p_companyid: localStorage.getItem('companyid'),
        p_pr_number: ParentRollNumber,
        p_user_name: localStorage.getItem('userID'),
        p_child_roll_detail: setChildRollsDetails,
        p_shift_date: dayjs(shiftDate).format('YYYY-MM-DD hh:mm:ss'),
        p_shift_id: winderShiftCode.shiftid
    };

    await callApi(API_ENDPOINTS.PROD_MANAGEMENT_UPDATE_CHILD_ROLL_DETAIL, 'POST', { 'Content-Type': 'application/json' }, orderData)
        .then(data1 => {

            setSetwiseChildrollDetail(data1);
            get_SelectedLotNumber_status(data1);
            setseverityvalue('info');
            setmessageValue('New Child Roll approved Successfully');
            setAlertTitleValue('info');
            setOpen(true);

            const updateData = {
                p_companyid: localStorage.getItem('companyid'),
                p_pr_number: ParentRollNumber,
                p_user_name: localStorage.getItem('userID'),
                p_child_roll_detail: setChildRollsDetails,
            };


            // UPDATE PARENT ROLL STATUS
            const result = callApi(API_ENDPOINTS.PROD_MANAGEMENT_UPDATE_PARENT_ROLL_STATUS, 'POST', { 'Content-Type': 'application/json' }, updateData);
            if (result) {
                // logical changes
            }


            const orderDataFilter = {
                p_companyid: localStorage.getItem('companyid'),
                p_pr_number: ParentRollNumber,
                p_release_no: winderMoNumber,
                p_lot_no: winderMaNumber,
            };

            callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_APPROVED_CHILD_ROLL_List, 'POST', { 'Content-Type': 'application/json' }, orderDataFilter)
                .then(data2 => {
                    // setApprovedChildRollNumber(null);
                    setApprovedChildRollNumber(data2);
                    // console.log('selected Achievement Details', data2);
                    // setCreateChildBtnDisapled(true);

                    callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_APPROVED_CHILD_ROLL_ACHIEVEMENT, 'POST', { 'Content-Type': 'application/json' }, orderDataFilter)
                        .then(data3 => {
                            // setApprovedChildRollNumber(null);
                            setgetChildReelAchievement(data3);
                            // console.log('selected Achievement Details', data3);


                        })
                        .catch(error => {
                            // Update state with error message        
                            setseverityvalue('error');
                            setmessageValue('Unable to get approved child roll achievement List');
                            setAlertTitleValue('error');
                            setOpen(true);
                        });

                })
                .catch(error => {
                    // Update state with error message        
                    setseverityvalue('error');
                    setmessageValue('Unable to get approved child roll List');
                    setAlertTitleValue('error');
                    setOpen(true);
                });

        })
        .catch(error => {
            // Update state with error message        
            setseverityvalue('error');
            setmessageValue('Child roll approve process failed');
            setAlertTitleValue('error');
            setOpen(true);
        });


}

// const UpdateChildRollDetail = async (
//     open,
//     setOpen,
//     severityvalue,
//     setseverityvalue,
//     messageValue,
//     setmessageValue,
//     alertTitleValue,
//     setAlertTitleValue,
//     ParentRollNumber,
//     setChildRollsDetails,
//     get_SelectedLotNumber_status,
//     setSetwiseChildrollDetail,
//     setApprovedChildRollNumber,
//     setgetChildReelAchievement,
//     createChildBtnDisapled,
//     setCreateChildBtnDisapled,
//     winderMoNumber,
//     winderMaNumber,
//     shiftDate,
//     winderShiftCode
// ) => {
//     try {
//         setOpen(false);

//         const orderData = {
//             p_companyid: localStorage.getItem("companyid"),
//             p_pr_number: ParentRollNumber,
//             p_user_name: "thiravidam",
//             p_child_roll_detail: setChildRollsDetails,
//             p_shift_date: dayjs(shiftDate).format("YYYY-MM-DD hh:mm:ss"),
//             p_shift_id: winderShiftCode.shiftid,
//         };

//         // Call the API and await the response
//         const data1 = await callApi(
//             API_ENDPOINTS.PROD_MANAGEMENT_UPDATE_CHILD_ROLL_DETAIL,
//             "POST",
//             { "Content-Type": "application/json" },
//             orderData
//         );

//         setSetwiseChildrollDetail(data1);
//         get_SelectedLotNumber_status(data1);

//         setseverityvalue("info");
//         setmessageValue("New Child Roll approved Successfully");
//         setAlertTitleValue("info");
//         setOpen(true);

//         const updateData = {
//             p_companyid: localStorage.getItem("companyid"),
//             p_pr_number: ParentRollNumber,
//             p_user_name: "thiravidam",
//             p_child_roll_detail: setChildRollsDetails,
//         };

//         // Update Parent Roll Status
//         await callApi(
//             API_ENDPOINTS.PROD_MANAGEMENT_UPDATE_PARENT_ROLL_STATUS,
//             "POST",
//             { "Content-Type": "application/json" },
//             updateData
//         );

//         const orderDataFilter = {
//             p_companyid: localStorage.getItem("companyid"),
//             p_pr_number: ParentRollNumber,
//             p_release_no: winderMoNumber,
//             p_lot_no: winderMaNumber,
//         };

//         const data2 = await callApi(
//             API_ENDPOINTS.PROD_MANAGEMENT_GET_APPROVED_CHILD_ROLL_List,
//             "POST",
//             { "Content-Type": "application/json" },
//             orderDataFilter
//         );

//         setApprovedChildRollNumber(data2);

//         const data3 = await callApi(
//             API_ENDPOINTS.PROD_MANAGEMENT_GET_APPROVED_CHILD_ROLL_ACHIEVEMENT,
//             "POST",
//             { "Content-Type": "application/json" },
//             orderDataFilter
//         );

//         setgetChildReelAchievement(data3);
//     } catch (error) {
//         // Handle errors and update UI accordingly
//         setseverityvalue("error");
//         setmessageValue(
//             error.message || "Child roll approval or data fetching failed"
//         );
//         setAlertTitleValue("error");
//         setOpen(true);

//         console.error("Error in UpdateChildRollDetail:", error);
//     }
// };

export default UpdateChildRollDetail











